import React, { useEffect, useState } from "react";
import { IProps, IShift } from "./interface";
import ShiftReviewService from "../../services/shiftReviewService";
import "./shiftreview.css";
import Shift from "./shift";
import { useHistory, useLocation } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "../../state/index";
import { bindActionCreators } from "redux";
import { Button } from "react-bootstrap";
// Redux end.

export const ShiftReview = (props: IProps) => {
  const [shifts, setShifts] = useState<IShift[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [failResponseMessage, setFailResponseMessage] = useState<any>();
  const [roles, setRoles] = useState<any[]>();
  // Redux
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreators.authActions, dispatch);
  const state = useSelector((state: State) => state);
  const { isLoggedIn, user } = state.authReducer;
  const stateLanguage = state.languageReducer;
  const [languageData, setLanguageData] = useState<any>();
  const history = useHistory();

  const id = useQuery().get("shiftsentityid");

  useEffect(() => {
    setLanguageData(stateLanguage);
  }, [stateLanguage]);

  useEffect(() => {
    console.log(props);
    if (!isLoggedIn) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    if (user && user.roles) {
      setRoles(user.roles);
    }
  }, [user]);

  useEffect(() => {
    getShifts(id);
  }, [id]);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const getShifts = async (id: any) => {
    try {
      setIsLoading(true);
      const response: any = await ShiftReviewService.getShiftsReview(id);
      console.log(response);
      const updatedShifts = response.data.map((shift: IShift) => {
        return { ...shift, isSaving: false, isSaveFailed: false };
      });
      setFailResponseMessage(null);
      setShifts(updatedShifts);
      setIsLoading(false);
    } catch (e: any) {
      console.dir(e);
      if (typeof e.response === "undefined") {
        //TODO server is unreachable implementation.
      } else if (e.response && e.response.status === 401) {
        if (isLoggedIn) {
          dispatch(logout());
        }
        history.push("/login");
      } else if (e.response && e.response.status === 423) {
        setFailResponseMessage(e.response.data);
      } else if (e.response.status === 403) {
        setFailResponseMessage({ message: e.response.data.error });
      }
      setIsLoading(false);
    }
  };

  const handleSave = async (shiftEntityId: number) => {
    const updatedShifts = shifts.map((shift: any) => {
      if (shift.shiftsEntityId === shiftEntityId) {
        shift.isSaving = true;
        return shift;
      }
      return shift;
    });
    setShifts(updatedShifts);
    try {
      const response = await ShiftReviewService.saveShift({
        shiftEntityId: shiftEntityId,
      });
      console.log(shifts);
      if (shifts.length === 1) {
        history.push("/shiftreview");
      }
      console.log(response);
      const afterSaveShifts = shifts.filter((shift: any) => {
        if (shift.shiftsEntityId === shiftEntityId) {
          return false;
        }
        return true;
      });
      setShifts(afterSaveShifts);
    } catch (error: any) {
      console.dir(error);
      console.dir(error.message);
      const afterSaveShifts = shifts.map((shift: any) => {
        if (shift.shiftsEntityId === shiftEntityId) {
          shift.isSaving = false;
          shift.isSaveFailed = true;
          return shift;
        }
        return shift;
      });
      setShifts(afterSaveShifts);
    }
  };

  const spinner = (
    <div>
      <div className="d-flex justify-content-center ">
        <div className="spinner-border spinner" role="status"></div>
      </div>
      <div
        style={{ marginTop: "1.5%" }}
        className="d-flex justify-content-center"
      >
        <p style={{ fontStyle: "oblique" }}>
          {languageData?.data?.shiftReview?.loading}
        </p>
      </div>
    </div>
  );

  return (
    <div>
      {isLoading && spinner}
      {failResponseMessage && (
        <div>
          <h1>{failResponseMessage.message}</h1>
          {failResponseMessage.details &&
            failResponseMessage.details.map((detail: any) => {
              return <h4>{detail}</h4>;
            })}
        </div>
      )}
      {shifts.map((shift: any, index: number) => {
        return (
          <Shift
            key={index}
            shiftDetails={shift}
            saveButtonClicked={handleSave}
            roles={roles}
            languageData={languageData}
          />
        );
      })}
    </div>
  );
};
